import { A1_POWEREDBY_COLOR_PRIMARY, EVENTS_URL } from '../config';
import { useHistory } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import ConfirmationPageLoading from '../components/confirmation/ConfirmationLoading.component';
import ConfirmationPageLoaded from '../components/confirmation/ConfirmationPageLoaded.component';
import { ConfirmationPageEventDocument, ConfirmationPageEventQuery } from '../graphql/graphql';
import { useContext, useEffect } from 'react';
import { CartContext } from '../components/providers/cart.tsx';
import { isReallyEmpty } from '../utils/validators.ts';
import useEventPixel from '../hooks/useEventPixel.tsx';
import { formatPrimaryColor } from '../utils/formatter.ts';

export function ConfirmationPage() {
    const { t } = useTranslation();
    const { currentEventId, processedOrderId } = useContext(CartContext);
    const history = useHistory();

    const { loading, data, error } = useQuery<ConfirmationPageEventQuery>(
        ConfirmationPageEventDocument,
        {
            variables: {
                eventId: currentEventId!,
            },
            skip: !currentEventId,
        }
    );

    const { trackEvent, initialized } = useEventPixel(currentEventId!);

    useEffect(() => {
        if (!processedOrderId) {
            if (currentEventId) {
                history.push(`/${currentEventId}`);
            } else {
                window.location.href = EVENTS_URL;
            }
        }
    }, []);

    if (!loading && error) {
        return <>{t('confirmationPage.errorLoadingData', 'Error Loading Data')}</>;
    }
    const organizerThemeColor = data?.event?.organizerColor || A1_POWEREDBY_COLOR_PRIMARY;

    const organizerPrimaryColor = formatPrimaryColor(
        data?.event?.eventType,
        data?.event?.organizerType,
        organizerThemeColor
    );

    const hasAdditionalTerms =
        data?.event?.additionalTerms != null && !isReallyEmpty(data?.event?.additionalTerms);

    return (
        <>
            {loading ? (
                <ConfirmationPageLoading />
            ) : (
                <ConfirmationPageLoaded
                    hasAdditionalTerms={hasAdditionalTerms}
                    event={data!.event}
                    organizerPrimaryColor={organizerPrimaryColor}
                    initialized={initialized}
                    trackEvent={trackEvent}
                />
            )}
        </>
    );
}
